import type { Feature } from 'api';

export const formatDirtScore = (score?: number | Feature) => {
  const formattedScore = typeof score === 'number' ? score : score?.mean;

  if (!formattedScore) return 'N/A';
  if (formattedScore >= 0 && formattedScore <= 0.899) return 'Very clean';
  if (formattedScore >= 0.9 && formattedScore <= 1.899) return 'Clean';
  if (formattedScore >= 1.9 && formattedScore <= 2.499) return 'Average';
  if (formattedScore >= 2.5 && formattedScore <= 2.899) return 'Dirty';
  if (formattedScore >= 2.9 && formattedScore <= 3) return 'Very dirty';
  return formattedScore.toFixed(2);
};
